const genrePatterns = {
  HipHop: {
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0],
    openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  },

  Trap: {
    kick:[1,0,0,0,0,1,0,0,1,0,0,1,0,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,1],
  },

  Drill:{
    kick:[1,0,0,0,0,0,0,1,0,0,1,0,0,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[0,1,0,1,1,0,1,0,0,1,0,1,1,0,1,0],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1],
  },

  BoomBap:{
    kick:[1,0,0,0,1,0,0,1,1,0,0,0,1,0,0,0],
    snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    openhat:[0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,1],
  },

  RnB:{
    kick:[1,0,0,0,1,0,0,0,0,1,0,0,1,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  },

  Funk:{
    kick:[1,0,0,1,1,0,1,0,1,0,0,1,1,0,1,0],
    snare:[0,0,1,0,0,1,0,1,0,0,1,0,0,1,0,1],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,1],
    openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
  },

  Jazz:{
    kick:[1,0,0,0,1,0,0,1,0,0,1,0,0,0,1,0],
    snare:[0,1,0,1,0,1,0,0,1,0,1,0,1,0,1,0],
    hihat:[1,1,1,0,1,1,1,0,1,1,1,0,1,1,1,0],
    clap:[0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0],
    openhat:[0,0,1,0,1,0,0,1,0,1,0,1,0,1,0,1],
  },

  Blues:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,0,1,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
    clap:[0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,1],
    openhat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],
  },

  Rock:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  },

  Metal:{
    kick:[1,1,0,1,1,0,1,1,1,1,0,1,1,0,1,1],
    snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    openhat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],
  },

  Pop:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  },

  House:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  },

  Techno:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  },

  Trance:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  },

  Dubstep:{
    kick:[1,0,0,1,0,0,0,0,1,0,1,0,0,0,0,1],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[1,1,0,1,1,0,1,1,1,1,0,1,1,0,1,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],
  },

  Reggae:{
    kick:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],
    snare:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],
    hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],
    clap:[1,0,0,0,0,0,1,0,1,0,0,1,0,1,0,0],
    openhat:[0,0,1,1,0,0,0,0,1,1,0,0,0,0,1,1],
  },

  Country:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0],
  },

  Latin:{
    kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],
    snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  },

  Afrobeat:{
    kick:[1,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0],
    snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
    hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
    clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
    openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
  },

  EDM:{
    kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],
    snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    hihat:[1,1,1,0,1,1,1,0,1,1,1,0,1,1,1,0],
    clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
    openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
  },
Bollywood: {
  kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
},

BaileFunk: {
  kick:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,0],
  snare:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  hihat:[1,1,0,1,1,0,1,1,1,1,0,1,1,0,1,1],
  clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

Phonk: {
  kick:[1,0,0,1,0,0,1,0,1,0,0,0,1,0,1,0],
  snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  hihat:[1,1,1,0,1,1,0,1,1,0,1,1,1,0,1,1],
  clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  openhat:[0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0],
},

Amapiano: {
  kick:[1,0,0,0,1,0,1,0,0,1,0,0,1,0,0,0],
  snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  hihat:[1,0,1,1,1,0,1,1,1,0,1,1,1,0,1,1],
  clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  openhat:[0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0],
},

AfroHouse: {
  kick:[1,0,0,0,1,0,1,0,1,0,0,0,1,0,1,0],
  snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
  clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],
  openhat:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],
},

Bhangra: {
  kick:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
},

PunjabiPop: {
  kick:[1,0,0,1,1,0,0,0,1,0,1,0,1,0,0,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

TamilKuthu: {
  kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],
  snare:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],
  openhat:[0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0],
},

KollywoodMass: {
  kick:[1,0,1,0,0,1,1,0,1,0,1,0,0,1,1,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

TollywoodMass: {
  kick:[1,0,0,1,1,0,1,0,1,0,0,1,1,0,1,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,0,0,1,0,1,0,0,0,0,1,0,0,1,0,0],
}, 

CarnaticFusion: {
  kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
},

Qawwali: {
  kick:[1,0,0,0,1,0,1,0,1,0,0,0,1,0,1,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,0,1,1,1,0,1,1,1,0,1,1,1,0,1,1],
  clap:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
  openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
},

ArabicPop: {
  kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

TurkishPop: {
  kick:[1,0,0,1,1,0,0,0,1,0,0,1,1,0,0,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
},

PersianPop: {
  kick:[1,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
  clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

Flamenco: {
  kick:[1,0,0,1,0,1,0,1,1,0,0,1,0,1,0,1],
  snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],
  openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
},

Samba: {
  kick:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,1],
  snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

BossaNova: {
  kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],
  snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
  hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
  clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
},

Reggaeton: {
  kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],
  snare:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],
},

Dancehall: {
  kick:[1,0,0,1,1,0,0,0,1,0,0,1,1,0,0,0],
  snare:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],
  clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],
  openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],
},
Cumbia:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Merengue:{kick:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],snare:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},
Bachata:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},
Salsa:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Forro:{kick:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Pagode:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},
Axe:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Mambo:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},
ChaChaCha:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,1,0,1,1,1,0,1,1,1,0,1,1,1,0],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},
Rumba:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Highlife:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Makossa:{kick:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,1],snare:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],openhat:[0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0]},
Soukous:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Gqom:{kick:[1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},
Kwaito:{kick:[1,0,0,0,1,0,1,0,1,0,0,0,1,0,1,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0]},
Celtic:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},
IrishFolk:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,0,1,1,1,0,1,1,1,0,1,1,1,0],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Balkan:{kick:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,1],snare:[0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},
Greek:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},
Klezmer:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],hihat:[1,1,1,0,1,1,1,0,1,1,1,0,1,1,1,0],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},
JPop:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

JRock:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],openhat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1]},

CityPop:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

Enka:{kick:[1,0,0,0,0,0,1,0,1,0,0,0,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

Anime:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,1,0,0,1,0,0,1,0,1,0,0,1,0]},

KPop:{kick:[1,0,0,1,1,0,0,0,1,0,1,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0]},

Trot:{kick:[1,0,0,0,1,0,0,1,1,0,0,0,1,0,0,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

Mandopop:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

Cantopop:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

ThaiPop:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0]},

VPop:{kick:[1,0,0,0,1,0,1,0,1,0,0,0,1,0,1,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

PinoyPop:{kick:[1,0,1,0,0,1,0,0,1,0,1,0,0,1,0,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

Dangdut:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

Gamelan:{kick:[1,0,0,0,1,0,0,1,1,0,0,0,1,0,0,1],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},
Garba:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

Dandiya:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

Lavani:{kick:[1,0,1,0,0,1,1,0,1,0,1,0,0,1,1,0],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

Bihu:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

Rajasthani:{kick:[1,0,0,1,0,1,0,0,1,0,0,1,0,1,0,0],snare:[0,1,0,0,1,0,0,1,0,1,0,0,1,0,0,1],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

KashmiriFolk:{kick:[1,0,0,0,1,0,1,0,1,0,0,0,1,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

BengaliFolk:{kick:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

Baul:{kick:[1,0,0,0,1,0,0,1,1,0,0,0,1,0,0,1],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

MarathiDhol:{kick:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],snare:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

KeralaChenda:{kick:[1,1,0,1,1,0,1,1,1,1,0,1,1,0,1,1],snare:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

Yakshagana:{kick:[1,0,1,0,1,0,0,1,1,0,1,0,1,0,0,1],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

GoanKonkani:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

Sufi:{kick:[1,0,0,0,1,0,1,0,1,0,0,0,1,0,1,0],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,0,1,1,1,0,1,1,1,0,1,1,1,0,1,1],clap:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

IndianClassical:{kick:[1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0],snare:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},
FutureBass:{kick:[1,0,0,0,1,0,0,1,1,0,0,0,1,0,0,1],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,1,0,1,1,1,0,1,1,1,0,1,1,1,0],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0]},

FutureHouse:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

DeepHouse:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0]},

ProgressiveHouse:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

MelodicTechno:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

Hardstyle:{kick:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1]},

Hardcore:{kick:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],snare:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0],openhat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1]},

Psytrance:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

GoaTrance:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},

UKGarage:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,0,1,1,1,0,1,1,1,0,1,1,1,0,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

DrumAndBass:{kick:[1,0,0,0,0,0,1,0,1,0,0,0,0,1,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1]},

Jungle:{kick:[1,0,0,1,0,0,1,0,1,0,1,0,0,1,0,0],snare:[0,0,1,0,1,0,0,0,0,0,1,0,1,0,0,0],hihat:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],clap:[0,0,1,0,1,0,0,0,0,0,1,0,1,0,0,0],openhat:[0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1]},

Breakbeat:{kick:[1,0,0,1,0,0,1,0,1,0,1,0,0,1,0,0],snare:[0,0,1,0,1,0,0,0,0,0,1,0,1,0,0,0],hihat:[1,1,0,1,1,1,0,1,1,1,0,1,1,1,0,1],clap:[0,0,1,0,1,0,0,0,0,0,1,0,1,0,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

Garage:{kick:[1,0,0,1,0,0,1,0,1,0,0,1,0,0,1,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,0,1,1,1,0,1,1,1,0,1,1,1,0,1,1],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0]},

LoFi:{kick:[1,0,0,0,1,0,0,1,0,0,1,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1]},

Synthwave:{kick:[1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1]},

Vaporwave:{kick:[1,0,0,0,0,0,1,0,1,0,0,0,0,0,1,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,0,1,0,0,0,0,0,0,0,1,0,0,0,0]},

Chillstep:{kick:[1,0,0,0,0,0,1,0,1,0,0,0,0,1,0,0],snare:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],hihat:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0],clap:[0,0,0,0,1,0,0,0,0,0,0,0,1,0,0,0],openhat:[0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0]},
};

export default genrePatterns;